<template lang="pug">
main.index__wrapper
  section.index
    .index__column(v-for="index in indices")
      article.index-item
        .index-item__thumbnail
          img(v-lazy="index.screenshot_small", :src="index.screenshot_small")
          .index-item__button(@click="showIndex(index.id)")
            i.icon.ion-ios-search-strong
        .index-item__text
          h3: a(v-bind:href="index.url", target="_blank") {{ index.title }}
  //- Sidebar
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Sidebar from "../components/Sidebar.vue";

export default {
  components: {
    Sidebar,
  },
  beforeMount() {
    window.addEventListener("scroll", this.scrollHandler);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollHandler);
  },
  computed: {
    ...mapState(["indices", "index", "page", "query", "noScroll"]),
  },
  methods: {
    ...mapActions(["fetchIndices", "fetchIndex"]),
    ...mapMutations(["toggleModal", "stopScroll", "toggleLoading", "showNext"]),
    showIndex(id) {
      const el = document.body;
      el.classList.add("noscroll");
      this.toggleLoading();
      this.fetchIndex(id);
      window.setTimeout(() => {
        this.toggleLoading();
        this.toggleModal();
      }, 1000);
    },
    scrollHandler: function (e) {
      if (!this.noScroll) {
        if (
          e.target.scrollingElement.scrollTop +
            e.target.scrollingElement.clientHeight +
            1000 >=
          e.target.scrollingElement.scrollHeight
        ) {
          this.toggleLoading();
          this.stopScroll();
          this.showNext();
          window.setTimeout(() => {
            this.fetchIndices({ page: this.page, query: this.query });
            this.toggleLoading();
          }, 2000);
        }
      }
    },
  },
};
</script>


<style lang="scss">
@import "../../../assets/stylesheets/variables";

.index {
  width: 100%;
  min-height: calc(100vh - 380px);
  margin: 130px auto 0;
  padding: $space-l;
  display: flex;
  flex-wrap: wrap;
  background: var(--secondaryBackground);
  transition: 0.3s;
  position: relative;
  z-index: 9997;
  @media only screen and( max-width: $tablet) {
    padding: $space-m;
  }
  &__wrapper {
    min-height: calc(100vh);
    display: flex;
  }
  &__column {
    width: 19.2%;
    margin-right: 1%;
    &:nth-child(5n) {
      margin-right: 0%;
    }
    &:nth-child(5n + 1) {
      margin-left: 0%;
    }
    @media only screen and( max-width: 1440px) {
      width: 23.5%;
      margin-right: 2%;
      &:nth-child(5n) {
        margin-right: inherit;
      }
      &:nth-child(5n + 1) {
        margin-left: inherit;
      }
      &:nth-child(4n) {
        margin-right: 0%;
      }
      &:nth-child(4n + 1) {
        margin-left: 0%;
      }
    }
    @media only screen and( max-width: 1024px) {
      width: 32%;
      margin-right: 2%;
      &:first-child {
        margin-left: 0;
      }
      &:nth-child(4n) {
        margin-right: 2%;
      }
      &:nth-child(4n + 1) {
        margin-left: 0%;
      }
      &:nth-child(3n) {
        margin-right: 0%;
      }
    }
    @media only screen and( max-width: $tablet) {
      width: 100%;
      margin-right: 0;
    }
    img {
      width: 100%;
      height: auto;
      vertical-align: bottom;
    }
  }
  &-item {
    margin-bottom: $space-l;
    &__thumbnail {
      height: 300px;
      background: var(--tertiaryBackground);
      box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.1);
      overflow: hidden;
      position: relative;
      // @media only screen and( max-width: $tablet) {
      //   background: transparent;
      // }
      img {
        transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
        backface-visibility: hidden;
      }
      &:after {
        content: "";
        display: block;
        width: 50px;
        height: 50px;
        background: #000;
        position: absolute;
        bottom: -25px;
        right: -25px;
        transform: rotate(-45deg);
        opacity: 0;
        transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
        @media only screen and( max-width: $tablet) {
          opacity: 1;
        }
      }
      &:hover {
        &:after {
          opacity: 1;
          transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
        }
        img {
          transform: translateY(-300px);
          transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
          @media only screen and( max-width: $tablet) {
            transform: translateY(0px);
          }
        }
      }
    }
    &__text {
      margin-top: $space-s;
      a {
        font-size: $font-xs;
        line-height: 1.5;
        color: var(--primaryColor);
        text-decoration: none;
      }
    }
    &__button {
      content: "";
      display: block;
      width: 50px;
      height: 50px;
      background: #000;
      position: absolute;
      bottom: -25px;
      right: -25px;
      z-index: 9997;
      transform: rotate(-45deg);
      opacity: 0;
      transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
      text-align: center;
      @media only screen and( max-width: $tablet) {
        opacity: 1;
        width: 60px;
        height: 60px;
        bottom: -30px;
        right: -30px;
      }
      .icon {
        display: block;
        position: relative;
        z-index: 9999;
        color: #fff;
        transform: rotate(45deg);
        margin-top: 2px;
        @media only screen and( max-width: $tablet) {
          margin-top: 4px;
          font-size: 16px;
        }
        &:before {
          font-weight: bold;
        }
      }
      &:hover {
        opacity: 1;
        transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
      }
    }
  }
}

img[lazy="loaded"] {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-name: scrollIn;
}

@keyframes scrollIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>